<section class="benefits-section">
    <div class="container">
      <div class="section__header">
        <h2 class="section__title">Beneficios clave de Zapphira.ai</h2>
        <p class="section__subtitle">
          Descubre cómo nuestro agente conversacional puede transformar tu empresa con tecnología IA de vanguardia
        </p>
      </div>
      
      <div class="benefits-grid">
        <div class="benefit-card" *ngFor="let benefit of benefits" 
             [class.benefit-card--expanded]="isBenefitExpanded(benefit.id)"
             (click)="toggleBenefit(benefit.id)">
          <div class="benefit-card__header">
            <div class="benefit-card__icon">
              <i class="bi {{ benefit.icon }}"></i>
            </div>
            <div class="benefit-card__title-container">
              <h3 class="benefit-card__title">{{ benefit.title }}</h3>
              <i class="bi {{ isBenefitExpanded(benefit.id) ? 'bi-chevron-up' : 'bi-chevron-down' }} benefit-card__toggle"></i>
            </div>
          </div>
          
          <p class="benefit-card__description">{{ benefit.description }}</p>
          
          <div class="benefit-card__features">
            <ul class="benefit-card__features-list">
              <li class="benefit-card__feature" *ngFor="let feature of benefit.features">
                <i class="bi bi-check-circle-fill"></i>
                <span>{{ feature }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <!-- Resultados demostrados -->
      <div class="results">
        <h3 class="results__title">Resultados demostrados</h3>
        
        <div class="results-grid">
          <div class="result-card">
            <div class="result-card__number">60%</div>
            <div class="result-card__label">Reducción en tiempo de respuesta</div>
          </div>
          
          <div class="result-card">
            <div class="result-card__number">40%</div>
            <div class="result-card__label">Disminución en costos operativos</div>
          </div>
          
          <div class="result-card">
            <div class="result-card__number">85%</div>
            <div class="result-card__label">Resolución en primera interacción</div>
          </div>
          
          <div class="result-card">
            <div class="result-card__number">24/7</div>
            <div class="result-card__label">Disponibilidad permanente</div>
          </div>
        </div>
      </div>
      
    </div>
  </section>